export function getFormsPreviewUrl(): { url: string; origin: string } {
  // Check if we're running locally
  if (window.location.hostname.includes('local.feathr.app')) {
    return {
      url: 'https://local.feathr.app:9007/preview.html',
      origin: 'https://local.feathr.app:9007',
    };
  }

  // Detect environment from BLACKBOX_URL
  if (BLACKBOX_URL.includes('blackbox.feathr.co')) {
    // Production
    return {
      url: 'https://forms.feathr.co/preview-v2.html',
      origin: 'https://forms.feathr.co',
    };
  } else if (BLACKBOX_URL.includes('blackbox-staging.feathr.co')) {
    // Staging
    return {
      url: 'https://forms-staging.feathr.co/preview-v2.html',
      origin: 'https://forms-staging.feathr.co',
    };
  } else if (BLACKBOX_URL.includes('blackbox-qa.feathr.co')) {
    // QA
    return {
      url: 'https://forms-qa.feathr.co/preview-v2.html',
      origin: 'https://forms-qa.feathr.co',
    };
  } else if (BLACKBOX_URL.includes('blackbox-dev.feathr.co')) {
    return {
      url: 'https://forms-dev.feathr.co/preview-v2.html',
      origin: 'https://forms-dev.feathr.co',
    };
  }

  // Default to local
  return {
    url: 'https://local.feathr.app:9007/preview.html',
    origin: 'https://local.feathr.app:9007',
  };
}
